import React from 'react';
import { twMerge } from 'tailwind-merge';

const IconDetail = ({ value, text, icon, className, ...props }) => (
  <div className={twMerge('flex items-center gap-2 md:gap-3', className)} {...props}>
    <div className="relative flex items-center justify-center border p-2 md:p-3">{icon}</div>
    <div className="text-left flex-col space-y-0 md:space-y-1">
      <span className="block text-xs sm:text-base uppercase ">{value}</span>
      <span className="block text-[10px] sm:text-xs text-gray-600">{text}</span>
    </div>
  </div>
);

export default IconDetail;
